import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  getApprovalFlowScreen,
  saveApprovalFlow,
} from '@ebalance/proto/bffuser/v1/approval_flow_service-ApprovalFlowService_connectquery'
import { getWorkflowTemplateFormOptions } from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

export function useSaveApprovalFlow(): InvalidatingMutationResultFor<
  typeof saveApprovalFlow
> {
  return useInvalidatingMutation(saveApprovalFlow, [
    // 保存成功後に画面データ (全プロセス設定 + 承認者候補) を再取得して最新化。
    // 集約 endpoint なので候補一覧も併せて revalidate されるが、画面ロード単位の
    // 1 query に集約した設計上の許容範囲。
    createConnectQueryKey({
      schema: getApprovalFlowScreen,
      cardinality: 'finite',
    }),
    // workflow-template-form-options-bff-aggregation design: テンプレート
    // editor が使う集約 query (`getWorkflowTemplateFormOptions`) の
    // approval_processes 投影も同じ backend 設定を投影するため invalidate する
    // (旧 `getApprovalFlowScreen` key は他画面 consumer が使うため残置)。
    createConnectQueryKey({
      schema: getWorkflowTemplateFormOptions,
      cardinality: 'finite',
    }),
  ])
}
